export const getMembers = (t) => [
  {
    id: 1,
    name: 'Denise',
    position: t('holiday-tips:positions.leadConcierge'),
    image: 'Denise.png',
  },
  {
    id: 2,
    name: 'Sierra',
    position: t('holiday-tips:positions.frontDesk'),
    image: 'Sierra.png',
  },
  {
    id: 3,
    name: 'Naeem',
    position: t('holiday-tips:positions.frontDesk'),
    image: 'Naeem.png',
  },
  {
    id: 4,
    name: 'Tiffany',
    position: t('holiday-tips:positions.frontDesk'),
    image: 'Tiffany.png',
  },
  {
    id: 5,
    name: 'Juan',
    position: t('holiday-tips:positions.frontDesk'),
    image: 'Juan.png',
  },
  {
    id: 6,
    name: 'Jennie',
    position: t('holiday-tips:positions.packageTeamLead'),
    image: 'Jennie.png',
  },
  {
    id: 7,
    name: 'Naniha',
    position: t('holiday-tips:positions.frontDesk'),
    image: 'Naniha.png',
  },
  {
    id: 8,
    name: 'Rashira',
    position: t('holiday-tips:positions.packages'),
    image: 'Rashira.png',
  },
  {
    id: 9,
    name: 'Teodor',
    position: t('holiday-tips:positions.chiefEngineer'),
    image: 'Teodor .png',
  },
  {
    id: 10,
    name: 'Scott',
    position: t('holiday-tips:positions.assistantChiefEngineer'),
    image: 'Scott .png',
  },
  {
    id: 11,
    name: 'Daniel',
    position: t('holiday-tips:positions.shiftAssistantEngineer'),
    image: 'Daniel.png',
  },
  {
    id: 12,
    name: 'Robert',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Robert.png',
  },
  {
    id: 13,
    name: 'Sergio',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Sergio.png',
  },
  {
    id: 21,
    name: 'Jemaris',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Jemaris.png',
  },
  {
    id: 22,
    name: 'Jose',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Jose.png',
  },
  {
    id: 14,
    name: 'Chris',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Chris.png',
  },
  {
    id: 15,
    name: 'Erika',
    position: t('holiday-tips:positions.maintenance'),
    image: 'Erika.png',
  },
  {
    id: 16,
    name: 'Jasminko',
    position: t('holiday-tips:positions.maintenance'),
    image: 'Jasminko.png',
  },
  {
    id: 17,
    name: 'Enver',
    position: t('holiday-tips:positions.maintenance'),
    image: 'Enver.png',
  },
  {
    id: 18,
    name: 'Teresa',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Teresa.png',
  },
  {
    id: 19,
    name: 'Anthony',
    position: t('holiday-tips:positions.maintenance'),
    image: 'Anthony.png',
  },
  {
    id: 20,
    name: 'Michael',
    position: t('holiday-tips:positions.maintenanceTech'),
    image: 'Michael.png',
  },
]

export const MIN_TIP_AMOUNT = 1
export const MAX_TIP_AMOUNT = 10000

export const FIVE_TIP = '5'
export const TEN_TIP = '10'
export const TWENTY_TIP = '20'

export const TIP_OPTIONS = [FIVE_TIP, TEN_TIP, TWENTY_TIP]
export const TIP_MULTIPLIER = 100
